import { DashboardCard } from '@/components/ui/dashboard-card.tsx';

export const PlantsOverview = () => {
  const plants = [
    { name: 'Maltberg', status: 'Operational', soc: 90, production: 210.59, capacity: 600 },
    {
      name: 'ELNET - CUP Focsani',
      status: 'Operational',
      soc: 12.1,
      production: 0,
      capacity: 800,
    },
    { name: 'PPC Blue', status: 'Operational', soc: 87, production: 146.37, capacity: 500 },
    {
      name: 'OLY Storage',
      status: 'Operational',
      soc: 48.9,
      production: 610.61,
      capacity: 1200,
    },
  ];
  return (
    <DashboardCard>
      <div className="mb-4 text-base font-semibold">Plants Overview</div>
      <div className="flex flex-col gap-3.5 text-base">
        {plants.map((plant, idx) => (
          <div
            key={idx}
            className={[
              'pb-3',
              idx < plants.length - 1 ? 'border-b border-zinc-100' : '',
            ].join(' ')}
          >
            <div className="mb-1.5 flex items-center justify-between">
              <span className="font-semibold">{plant.name}</span>
              <span className="rounded bg-green-100 px-2 py-0.5 text-base font-semibold text-green-800">
                {plant.status}
              </span>
            </div>
            <div className="mb-1.5 flex items-center justify-between text-zinc-500">
              <span>SoC: {plant.soc}%</span>
              <span>{plant.production.toFixed(1)} kWh</span>
            </div>
            <div className="h-1 overflow-hidden rounded bg-zinc-100">
              <div
                className={[
                  'h-full',
                  plant.soc > 60
                    ? 'bg-green-500'
                    : plant.soc > 30
                      ? 'bg-amber-500'
                      : 'bg-red-500',
                ].join(' ')}
                style={{ width: `${plant.soc}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </DashboardCard>
  );
};

export default PlantsOverview;
